<script setup lang="ts">
</script>

<!-- eslint-disable -->
<template>
    <svg width="57" height="27" viewBox="0 0 57 27" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M29.5328 24.1366C10.8739 24.6179 -1.92385 22.3933 0.557465 12.0783C3.02752 1.81014 17.5885 -1.18765 33.3517 0.852013C41.3411 1.8858 50.5447 4.9703 54.1409 10.5911C61.4747 22.0536 48.6096 26.262 32.0884 26.7019C22.7651 26.9502 9.81005 24.0584 5.35648 19.3886" stroke="currentColor" stroke-width="1" stroke-linecap="round" vector-effect="non-scaling-stroke"/>
    </svg>
</template>
<!-- eslint-enable -->
